export const LIST_LIMIT = 16

export const AVATAR_MAX_SIZE = 200000

export const PAGE_QUERY_NAME = 'page'
